// @flow

import React, { useContext, useState } from 'react';
import { render } from 'react-dom';
import DocumentViewer from './DocumentViewer';
import { FILE_PATH } from './GlobalParams';

import Application from './components/Application';
import UserContext, { UserProvider } from './providers/UserProvider';
import { Router } from '@reach/router';
import Admin from './components/Admin';

const demoNode = document.querySelector('#app');

const AppStart = () => {
    const context = useContext(UserContext);
    const [user, setUser] = useState(context.user);
    const [pending, setPending] = useState(context.pending);
    return (
        <UserProvider value={{ user, pending, setPending, setUser }}>
            <Router>
                <Application path="/" />
                <Admin path="admin" />
            </Router>
        </UserProvider>
    );
};

if (FILE_PATH && FILE_PATH != '') {
    render(<DocumentViewer />, demoNode);
} else {
    render(<AppStart />, demoNode);
}



// WEBPACK FOOTER //
// ./demo/src/index.js